import { render } from "./CommissionDetailSection.vue?vue&type=template&id=15095b2b&scoped=true"
import script from "./CommissionDetailSection.vue?vue&type=script&lang=js"
export * from "./CommissionDetailSection.vue?vue&type=script&lang=js"

import "./CommissionDetailSection.vue?vue&type=style&index=0&id=15095b2b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15095b2b"

export default script